import {
  createAppeal,
  createFullSiteBan,
  createReport,
  decideAppeal,
  decideReportCase,
  escalateAppeal,
  escalateReportCase,
  getAppeal,
  getAppealReview,
  getReportCase,
  getStanding,
  getSurfaceStats,
  getUser,
  liftFullSiteBan,
  listAppealReviews,
  listAppeals,
  listFullSiteBans,
  listJudgedInputs,
  listRefusals,
  listReportCases,
  listSurfaces,
  listUserJudgements,
  listUsers,
  reclassify,
  withdrawAppeal,
} from "./endpoints";

export {
  ALL_MODERATION_PERMISSIONS,
  BAN_APPEAL_PERMISSIONS,
  type BanAppealSurface,
  banAppealable,
  type HumanQueue,
  labeledWhole,
  MODERATED_SURFACES,
  MODERATION_PERMISSIONS,
  queuePermission,
  STATS_PERMISSIONS,
  SURFACE_OF_SUBJECT,
  subjectTypesOf,
  surfaceAccess,
  workableSubjectTypes,
} from "./access";
export {
  appealOpen,
  automodUnavailable,
  moderationRefused,
  service,
  surfaceBanned,
} from "./endpoints";
export {
  AccountStanding,
  Appeal,
  AppealableRefusal,
  AppealedBan,
  AppealForReview,
  AppealId,
  AppealIdParams,
  AppealResponse,
  AppealReview,
  AppealScope,
  AppealStatus,
  AutomodFailureReason,
  BanAppeal,
  BanAppealReview,
  BanId,
  BanLiftReason,
  BanSurface,
  BanWindowInput,
  CategoryAssessment,
  ClassificationId,
  ClassificationIdParams,
  ClassificationOutcome,
  CreateAppealRequest,
  CreateFullSiteBanRequest,
  CreateReportRequest,
  DecideAppealRequest,
  DecideReportCaseRequest,
  FullSiteBan,
  FullSiteBanId,
  FullSiteBanIdParams,
  FullSiteBanResponse,
  ItemModeration,
  isReportReasonAllowed,
  JudgedInput,
  ListAppealReviewsQuery,
  ListAppealReviewsResponse,
  ListAppealsQuery,
  ListAppealsResponse,
  ListFullSiteBansQuery,
  ListFullSiteBansResponse,
  ListJudgedInputsQuery,
  ListJudgedInputsResponse,
  ListModeratedUsersQuery,
  ListModeratedUsersResponse,
  ListModerationSurfacesResponse,
  ListRefusalsQuery,
  ListRefusalsResponse,
  ListReportCasesQuery,
  ListReportCasesResponse,
  ListUserJudgementsQuery,
  ListUserJudgementsResponse,
  MandatoryTag,
  ModeratedSurface,
  ModeratedUser,
  ModerationCategory,
  ModerationClassification,
  ModerationInputKind,
  ModerationJudge,
  ModerationRefusal,
  ModerationSeverity,
  ModerationSnapshot,
  ModerationStats,
  ModerationStatsQuery,
  ModerationSubject,
  ModerationSubjectType,
  ModerationSurface,
  ModerationSurfaceOverview,
  ModerationWarning,
  OpenAppeal,
  PresetWords,
  ProfileModeration,
  ReclassifyRequest,
  RefusalAppeal,
  RefusedCategory,
  ReportCaseDetail,
  ReportCaseId,
  ReportCaseIdParams,
  ReportCaseReviewer,
  ReportCaseSummary,
  ReportReason,
  SnapshotFile,
  SnapshotId,
  StatsParams,
  SurfaceAccess,
  SurfaceBan,
  SurfaceStanding,
  UserBan,
  UserJudgement,
  UserModeration,
  UserParams,
} from "./schemas";

export const contract = {
  reports: { create: createReport },
  refusals: { list: listRefusals },
  appeals: {
    create: createAppeal,
    list: listAppeals,
    get: getAppeal,
    escalate: escalateAppeal,
    withdraw: withdrawAppeal,
    decide: decideAppeal,
    reviews: listAppealReviews,
    review: getAppealReview,
  },
  standing: { get: getStanding },
  users: { list: listUsers },
  surfaces: {
    list: listSurfaces,
    stats: getSurfaceStats,
    users: { get: getUser, judgements: listUserJudgements },
  },
  cases: {
    list: listReportCases,
    get: getReportCase,
    decide: decideReportCase,
    escalate: escalateReportCase,
  },
  classifications: { list: listJudgedInputs, reclassify },
  fullSiteBans: { list: listFullSiteBans, create: createFullSiteBan, lift: liftFullSiteBan },
} as const;
